import { gql } from 'apollo-angular';

export const AUTHORIZED_JURISDICTIONS_ALL = gql`
  query authorizedJurisdictionsAll(
    $skip: Int
    $take: Int
    $tenantId: UUID!
    $where: AuthorizedJurisdictionFilterInput
    $order: [AuthorizedJurisdictionSortInput!]
  ) {
    authorizedJurisdictionsAll(
      skip: $skip
      take: $take
      tenantId: $tenantId
      where: $where
      order: $order
    ) {
      totalCount
      items {
        authorizedTenantId
        wageAccessTypeId
        wageAccessType {
          accessType
          createdBy
          createdDate
          id
          modifiedBy
          modifiedDate
          name
          permissions
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;
